import React from 'react';
import cn from 'classnames';
import Modal from 'react-modal';
import styles from './confirmation-modal.module.scss';

import { ConfirmationTemplate } from '../../../templates/confirmation-template/base';
import { ConfirmationModalProps } from './confirmation-modal-props';

//I don't really like 'react-modal', but it works. 🙄
Modal.setAppElement(document.getElementById('root')!);

export function ConfirmationModal(props: ConfirmationModalProps) {
	const { Template = ConfirmationTemplate } = props;

	return (
		<Modal
			isOpen={props.isOpen}
			onRequestClose={props.onCancel}
			className={cn(styles.confirmationModal, props.className)}
			overlayClassName={cn(styles.confirmationBackground, props.overlayClassName)}
		>
			<Template {...props} />
		</Modal>
	);
}
